<div>
    <div class="mb-3">
        <label for="reviewed_by" class="form-label">Reviewed By</label>
        <input type="email" class="form-control" id="reviewed_by" name="reviewed_by" [(ngModel)]="reviewed_by_name">
    </div>
    <div class="mb-3">
        <label for="reviewed_date" class="form-label">Reviewed Date</label>
        <input type="date" class="form-control" id="reviewed_date" name="review_date" [(ngModel)]="review_date">
    </div>
    <div class="mb-3" style="text-align: center;margin-top: 25px;">
        <button type="button" class="btn btn-outline-success" style="width: 100%;" (click)="updateReviewData()">UPDATE</button>
    </div>
</div>